export const GUEST_PATIENT_ID = "guest_patient_id";
export const evaluationLSName = (evalName: string) => `evaluation_${evalName}`;
export const CHECKOUT_ERROR = "show_checkout_alert_msg";
export const GUEST_NAME = "guest_name";
export const CHECKOUT_FORM_DATA = "checkout_form_data";
